import { useRef, useState } from "react";
import { LacUnidadeTransporteInterface, SelectObjectRemoveInterface } from "../../../../interfaces";
import { getUuidV4, goToFocus } from "../../../../utils/utils";
import { Button, Col, Form, Modal } from "react-bootstrap";
import { ButtonRemover, ButtonTrash, JRow, JTable, JTBody, JTHead } from "../../../../components/Components";
import { useQuestion } from "../../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../../components/ModalMessage/useModalMessage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDoorClosed } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../app/store";
import {
    addLacreUnidadeTransporteNFe,
    removeLacreUnidadeTransporteNFe,
    removeLacreUnidadeTransporteNFeTodos
} from "../../../../features/manifestoSlice";

interface formProps {
    show: boolean;
    handleClose: () => void;
    id: number | string;
    idNFe: number | string;
}

const NFesUnidadeTranspInfLacreCarga: React.FC<formProps> = ({ id, show, handleClose, idNFe }) => {
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const [numeroLacre, setNumeroLacre] = useState<string>('');
    const numeroLacreRef = useRef<HTMLInputElement>(null);
    const [selecionado, setSelecionado] = useState<number | string>('');
    const lacres = useSelector((state: RootState) => state.manifesto.manifesto).infMunDescarga
        .flatMap(mun => mun.infNFe).filter(nfe => nfe?.id?.toString() === idNFe.toString())
        .flatMap(ut => ut?.infUnidTransp).filter(f => f?.id.toString() === id.toString())
        .flatMap(l => l?.lacUnidTransp ?? []);

    const dispatch = useDispatch();

    const validaPreenchimento = () => {
        if (numeroLacre.trim() === "") {
            goToFocus(numeroLacreRef);
            alertModal('Informe o número do lacre.');
            return false;
        }

        if (lacres.find(l => l?.nLacre.toString() === numeroLacre.toString().trim())) {
            alertModal('Lacre já adicionado.');
            return false;
        }

        return true;
    }

    const handleAddLacre = () => {
        if (validaPreenchimento()) {
            dispatch(addLacreUnidadeTransporteNFe({
                nfeId: idNFe,
                idUnidadeTransprte: id,
                lacre: {
                    nLacre: numeroLacre,
                    id: getUuidV4()
                }
            }));
            setNumeroLacre('');
        }
    }

    const handleRemoverLacre = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id);
        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
            title: "Confirmação"
        });
        if (confirmed) {
            dispatch(removeLacreUnidadeTransporteNFe({
                nfeId: idNFe,
                idLacre: value.id,
                idUnidadeTransprte: id
            }));
        }
        setSelecionado('');
    }

    const handleRemoverLacreTudo = async () => {
        if (lacres.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos os lacres ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removeLacreUnidadeTransporteNFeTodos({
                    nfeId: idNFe,
                    idUnidadeTransprte: id
                }));
            }
        }
    }

    return (<>
        <Modal show={show} onHide={handleClose} centered backdrop='static' fullscreen={'xl-down'} scrollable>
            <Modal.Header closeButton className="py-2 bg-success">
                <Modal.Title>Lacres
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <JRow className="mb-3">
                    <Col md>
                        <Form.Group controlId="nfe-lacre-ut-numero">
                            <Form.Label>Número do lacre</Form.Label>
                            <Form.Control value={numeroLacre}
                                placeholder="Digite o número + [Enter] para adicionar"
                                ref={numeroLacreRef}
                                name="numero"
                                onChange={(e) => setNumeroLacre(e.target.value)}
                                onKeyUp={(e) => {
                                    if (e.key === 'Enter') {
                                        handleAddLacre();
                                    }
                                }}
                            />
                        </Form.Group>
                    </Col>
                </JRow>

                <JTable>
                    <JTHead >
                        <tr>
                            <th className="text-center" style={{ width: '2.5rem' }}>
                                <ButtonTrash onClick={() => handleRemoverLacreTudo()} />
                            </th>
                            <th>Número do lacre</th>
                        </tr>
                    </JTHead>
                    <JTBody>
                        {lacres.map((item: LacUnidadeTransporteInterface) => {
                            return (
                                <tr key={item?.id}
                                    className={(item.id?.toString()) === selecionado.toString() ? 'table-danger' : ''}>
                                    <td className="text-center">
                                        <ButtonRemover onClick={
                                            () => handleRemoverLacre({ id: item.id ?? 0, title: item?.nLacre })} />
                                    </td>
                                    <td>
                                        {item?.nLacre}
                                    </td>
                                </tr>
                            )
                        })
                        }
                    </JTBody>
                </JTable>
                {ConfirmModal}
                {ModalMessageEl}
            </Modal.Body>

            <Modal.Footer className="py-2 ">
                <Button variant="secondary" onClick={handleClose} >
                    <FontAwesomeIcon icon={faDoorClosed} /> Fechar
                </Button>
            </Modal.Footer>
        </Modal>

    </>)
}
export default NFesUnidadeTranspInfLacreCarga;